export const testnetSymbolToAddressMap = {
  INJ: '0x85AbEac4F09762e28a49D7dA91260A46766F4F79',
  USDT: '0x87aB3B4C8661e07D6372361211B96ed4Dc36B1B5',
  APE: '0x44C21afAaF20c270EBbF5914Cfc3b5022173FEB7',
  USDC: '0xf9152067989BDc8783fF586624124C05A529A5D1',
  WETH: '0xdB309Bb079EB419C18fe7D568c61cD2FdB65D9aF',
}

export const devnetSymbolToAddressMap = {
  INJ: '0xBe8d71D26525440A03311cc7fa372262c5354A3c',
}

export const devnet1SymbolToAddressMap = {
  INJ: '0x87aB3B4C8661e07D6372361211B96ed4Dc36B1B5',
}
